export const alphaUpper = 'A-Z'
export const alphaLower = 'a-z'
// export const specialAlpha = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÑÒÓÔÕÖØÙÚÛÜÝßàáâãäåæçèéêëìíîïñòóôõöøùúûüýÿ';
export const specialAlpha = 'ßÖöËëÄäÜü'; // above code is left for easy reference.
export const apostrophe = '\'';
export const hyphen = '-';
export const forwardSlash = '/';
export const numbers = '0-9';
export const space = ' ';
export const ampersand = '&';
export const specialCharacters = '\.,/';
export const emailRegex = /^[\w!#$%&'*+./=?^`{|}~-]+@[\w.-]+\.[\da-z]+$/i;
